import store from "../store";
import {
  BUSINESS_UPDATE,
  ERROR_INITIAL,
  ERROR_UPDATE,
  EXPERIENCE_INITIAL,
  EXPERIENCE_UPDATE,
  USER_UPDATE,
} from "../store/slices";
import { AuthenticationInstance } from "./authenticationClass";
import { DatabaseInstance } from "./databaseClass";
import { ImageInstance } from "./imageClass";

class BusinessClass {
  constructor() {}

  public initialize = async () => {
    try {
      const activeBusiness = localStorage.getItem("activeBusiness");
      await this.getOwnedBusinesses();

      // TODO: ADD A CHECK TO MAKE SURE THE USER HAS ACCESS TO THE BUSINESS WE GOT FROM LOCALSTORAGE
      if (activeBusiness) {
        const business = JSON.parse(activeBusiness);
        await this.setBusiness(business);
      }
    } catch (error) {
      console.error("Error initializing business:", error);
      throw error;
    }
  };

  public getOwnedBusinesses = async () => {
    store.dispatch(
      BUSINESS_UPDATE({
        data: {
          ...store.getState().business,
          isLoading: true,
        },
      }),
    );

    const data = {
      endpoint: "users/get-user-list-businesses",
    };
    let businesses = await DatabaseInstance.getRecord(data);

    // if businesses is undefined then set it to an empty array
    if (!businesses) {
      businesses = [];
      // If you don't have access to any businesses, sign out the user.
    }

    if (!businesses.length) {
      // You don't have access to any businesses, sign out the user.
      AuthenticationInstance.handleSignOut("No businesses found for user.");
    }

    // check if user has access to canna42
    for (let business of businesses) {
      if (business[business.businessType].name === "canna42") {
        store.dispatch(
          USER_UPDATE({
            data: {
              ...store.getState().user,
              isAdmin: true,
            },
          }),
        );
      }
    }

    console.log("businesses", businesses);

    store.dispatch(
      BUSINESS_UPDATE({
        data: {
          ...store.getState().business,
          isLoading: false,
          businesses: businesses,
        },
      }),
    );

    return businesses;
  };

  private getBusiness = async (id: string, businessType: string) => {
    console.log("getting the business from db");
    let endpoint = businessType === "brand" ? `brands/get-brand/${id}` : `venues/get-venue/${id}`;

    const data = {
      endpoint,
    };

    const res = await DatabaseInstance.getRecord(data);
    return res;
  };

  public setBusiness = async (business: any) => {
    const res = await this.getBusiness(business.businessId, business.businessType);

    // check if the current route is /menu or /products then route to the correct page
    // if (
    //   window.location.pathname === '/menu' ||
    //   window.location.pathname === '/products'
    // ) {
    //   // window.location.href = `/${business.businessType}/${business.businessId}`;
    //   console.log('we are on a menu or products page')
    // }

    store.dispatch(
      BUSINESS_UPDATE({
        data: {
          ...store.getState().business,
          activeBusiness: res,
          businessType: business.businessType,
        },
      }),
    );

    localStorage.setItem("activeBusiness", JSON.stringify(business));

    return;
  };

  public getBusinessExperiences = async (id: string, businessType: string) => {
    console.log("getting the experiences business from db");
    try {
      store.dispatch(
        EXPERIENCE_UPDATE({
          data: {
            ...EXPERIENCE_INITIAL,
            isLoading: true,
          },
        }),
      );
      let endpoint = `experiences/get-business-experiences/?businessId=${id}&businessType=${businessType}`;

      const data = {
        endpoint,
      };
      const experiences = await DatabaseInstance.getRecord(data);
      store.dispatch(
        EXPERIENCE_UPDATE({
          data: {
            ...store.getState().experience,
            isLoading: false,
            experiences,
          },
        }),
      );
      return experiences;
    } catch (error) {
      console.error(error);
    }
  };

  public addExperience = async ({
    businessId,
    businessType,
    experience,
    imageUrl,
  }: {
    businessId: string | undefined;
    businessType: string;
    experience: any;
    imageUrl: any; //type file
  }) => {
    store.dispatch(
      EXPERIENCE_UPDATE({
        data: {
          ...store.getState().experience,
          isLoading: true,
        },
      }),
    );

    // Initialize as null so we can conditionally request them
    let imageUrlRes = null;

    if (imageUrl instanceof File) {
      imageUrlRes = await ImageInstance.uploadImageToS3(imageUrl, "experiences", experience.headline, false, true);
    }

    if (typeof imageUrl === "string") {
      imageUrlRes = {
        fileKey: imageUrl,
      };
    }

    // Check if uploads (if attempted) were successful
    if (!imageUrlRes) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to upload image to S3.",
          },
        }),
      );
      return;
    }
    //format the address for the location data
    const myAddress = `${experience.street1}, ${experience.city}, ${experience.state.abbr}, ${experience.zip} `;

    // Construct experience data, including image URLs if available
    const experienceData = {
      ...experience,
      ...(imageUrlRes && { imageUrl: imageUrlRes.fileKey }),
      locationAddress: myAddress,
    };

    console.log("experience goign to db", experienceData);
    const databaseData = {
      endpoint: `experiences/create-experience`,
      data: experienceData,
      headers: {
        actingasid: businessId,
        actingastype: businessType,
      },
    };

    console.log("database data", databaseData);

    const record = await DatabaseInstance.createRecord(databaseData);
    console.log("experienceData", experienceData);

    if (!record) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to add experience to database.",
          },
        }),
      );
      return false;
    }

    store.dispatch(
      EXPERIENCE_UPDATE({
        data: {
          ...store.getState().experience,
          isLoading: false,
        },
      }),
    );

    return true;
  };

  public updateExperience = async ({ data, id, imageUrl }: { data: any; id: number; imageUrl: any }) => {
    console.log("data", data);
    store.dispatch(
      EXPERIENCE_UPDATE({
        data: {
          ...store.getState().experience,
          isLoading: true,
        },
      }),
    );

    if (imageUrl !== null) {
      const imageUrlImgRes = await ImageInstance.uploadImageToS3(
        imageUrl,
        "experiences",
        data.headline.replace(/\s/g, ""),
        false,
        true,
      );

      imageUrlImgRes && (data.imageUrl = imageUrlImgRes.fileKey);
      // data.avatarUrl = avatarImgRes.fileKey;
    }

    if (data.headline) {
      data.headline = data.headline.trim();
    }

    const databaseData = {
      endpoint: `experiences/update-experience/${id}`,
      data: data,
    };

    console.log("databaseData", databaseData);

    const record = await DatabaseInstance.updateRecord(databaseData);

    console.log("record");

    if (!record) {
      store.dispatch(
        ERROR_UPDATE({
          data: {
            ...ERROR_INITIAL,
            error: true,
            message: "Failed to update experience in database.",
          },
        }),
      );
      return null;
    }

    // find the products in the product state and update the product
    const experiences = store.getState().experience.experiences;

    // update the product in the products array but keep the rest of the product in the productArray but update with new stuff

    const updatedExperiences = experiences.map((exp: any) => {
      if (exp.id === id) {
        return {
          ...exp,
          ...record,
        };
      }
      return exp;
    });

    console.log("updatedExperiencess", updatedExperiences);

    store.dispatch(
      EXPERIENCE_UPDATE({
        data: {
          ...store.getState().experience,
          isLoading: false,
          products: updatedExperiences,
        },
      }),
    );

    return record;
  };
}

const BusinessInstance = new BusinessClass();

export { BusinessInstance };
